export const HUNTR_STEPS = [
  {
    icon: 'Target',
    title: 'Sharpens Your ICP',
    body: 'Huntr studies your website, your offer and your best existing customers, then rewrites your ideal-customer profile in language a machine can act on.',
  },
  {
    icon: 'Search',
    title: 'Extracts Hidden Prospects',
    body: 'Deep-research AI scans 200M+ companies and 600M+ profiles to surface high-intent buyers that standard database filters never return.',
  },
  {
    icon: 'Send',
    title: 'Writes & Sends Outreach',
    body: 'Deeply personalised emails — researched per prospect, not templated — delivered through pre-warmed inboxes that protect your domain.',
  },
  {
    icon: 'CalendarCheck',
    title: 'Books the Meeting',
    body: 'Replies are read, handled and nurtured until the prospect lands on your calendar. You show up to the call, nothing else.',
  },
];

export const HUNTR_PLANS = [
  {
    leads: '100', price: 500, label: 'Launch', note: 'Prove the channel', badge: null,
    features: ['1 target market & ICP', '2 pre-warmed sending inboxes', 'Reply handling & booking', 'Monthly performance report'],
  },
  {
    leads: '200', price: 950, label: 'Pro', note: 'Consistent pipeline', badge: 'popular',
    features: ['Up to 3 ICPs & markets', '5 pre-warmed sending inboxes', 'CRM sync (HubSpot, Salesforce)', 'Weekly strategist review', 'Priority onboarding in 5 days'],
  },
  {
    leads: '500', price: 1750, label: 'Scale', note: 'Multi-market outbound', badge: 'best',
    features: ['Unlimited ICPs & markets', '12 pre-warmed sending inboxes', 'Multi-language outreach', 'Dedicated account strategist', 'A/B messaging programme'],
  },
  {
    leads: '1,000', price: 3200, label: 'Dominate', note: 'Category saturation', badge: null,
    features: ['Everything in Scale', '25+ sending inboxes & domains', 'Custom research signals', 'Executive quarterly strategy', 'Same-day priority support'],
  },
];

export const HUNTR_TESTIMONIALS = [
  {
    quote: "We've tried cold outreach with other agencies and got zero responses. With Huntr people actually reply, and what used to take hours takes me 15 minutes a day.",
    name: 'C. Rose',
  },
  {
    quote: 'We work with a lot of lead gen agencies and platforms, and Huntr’s infrastructure and support is the best one we’ve seen. You input the campaign, it runs, and Ahana Digital manages it for you.',
    name: 'C. Purcell',
  },
  {
    quote: 'I tried alternatives like Instantly and Apollo — you have to register a domain, set up DNS, warm it up for weeks. With Huntr, Ahana Digital does all the domain warming for you and you have >98% delivered emails … and every lead is the business owner, so the pilots convert extremely well.',
    name: 'J. Decker',
  },
];

// Annual billing: pay for 10 months, get 12.
export const ANNUAL_FACTOR = 10 / 12;

export const HUNTR_OLD_WAY = [
  'An SDR salary before a single meeting is booked',
  'Static databases everyone else already emailed',
  'Templated sequences that get marked as spam',
  'Weeks of list-building before outreach starts',
  'Pipeline that stops the moment someone resigns',
];

export const HUNTR_NEW_WAY = [
  'A fixed monthly fee, live within days',
  'Fresh, high-intent prospects found by deep research',
  'Per-prospect personalisation at machine volume',
  'Describe your buyer in plain English — that is the setup',
  'A pipeline that runs every single working day',
];

export const HUNTR_INCLUDED = [
  'ICP engineering session with a senior strategist',
  'Pre-warmed sending infrastructure & domain protection',
  'Deliverability monitoring and inbox rotation',
  'Reply handling, objection routing and follow-up',
  'Calendar integration and meeting confirmation',
  'Weekly performance reporting, platform-native',
];

export const HUNTR_FAQS = [
  {
    q: 'What counts as a lead?',
    a: 'A verified, in-ICP decision-maker researched and contacted by Huntr on your behalf — not a scraped row in a spreadsheet. Your plan sets the guaranteed volume per working day.',
  },
  {
    q: 'How fast does it go live?',
    a: 'Onboarding, ICP engineering and inbox warming typically complete inside 7 days. Outreach begins the moment deliverability is safe — never before.',
  },
  {
    q: 'Will this damage our domain reputation?',
    a: 'No. Huntr sends from pre-warmed infrastructure we own and monitor, with rotation and volume caps, so your primary domain is never exposed to cold-send risk.',
  },
  {
    q: 'What is the guarantee?',
    a: 'Guaranteed hot leads per day for 60 days, or your money back. If Huntr does not deliver the contracted volume, you do not pay for it.',
  },
  {
    q: 'Do we need to change our CRM?',
    a: 'No. Huntr routes into what you already use — HubSpot, Salesforce, Pipedrive or a shared inbox — and books straight into your existing calendar.',
  },
];